import { PcApiResponse } from '@/api/pc-api/types';
import { api } from '@/utils/api';

export const getMyBizCounts = () => {
  return api<PcApiResponse<number>>('get', '/pc-api/v1/mybiz/counts');
};
